import { ApiRequest } from '@sancare/typescript-commons/src/misc/api-request'
import { AbstractState } from '@sancare/typescript-commons/src/store/types'

import { EMPTY_HOME_STATS, HomeChartStat, HomeStats, PredictionModel } from '@/home/types'

export class HomeState extends AbstractState {
  homeStats: HomeStats = { ...EMPTY_HOME_STATS }
  homeChartStats: HomeChartStat[] = []
  predictionModels: PredictionModel[] = []
}

const baseUrl = '/api'

export const state = new HomeState()
state.requests = {
  getHomeStats: new ApiRequest('getHomeStats', 'GET', `${baseUrl}/home-stats`),
  getHomeChartStats: new ApiRequest('getHomeChartStats', 'GET', `${baseUrl}/home-chart-stats`),
  getPredictionModels: new ApiRequest('getPredictionModels', 'GET', `${baseUrl}/about/prediction-models`),
}
